import { createElement } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const textVariants = cva('', {
  variants: {
    variant: {
      body: 'text-base text-foreground',
      caption: 'text-sm text-muted',
      small: 'text-xs text-muted',
      muted: 'text-sm text-muted',
    },
  },
  defaultVariants: {
    variant: 'body',
  },
});

export interface TextProps<T extends React.ElementType = 'p'>
  extends React.HTMLAttributes<HTMLElement>,
    VariantProps<typeof textVariants> {
  as?: T;
}

export function Text<T extends React.ElementType = 'p'>({
  as,
  variant,
  className,
  ...props
}: TextProps<T> & Omit<React.ComponentPropsWithoutRef<T>, keyof TextProps<T>>) {
  const Component = as || 'p';
  return createElement(Component, {
    className: cn(textVariants({ variant }), className),
    ...props,
  });
}
